import ConnectWallet from './ConnectWallet'

export default ConnectWallet
